module.exports = __webpack_public_path__ + "static/img/avatar-s-18.6f5c3253.png";